// extracted by mini-css-extract-plugin
export default {"commentContainer":"CommentContainer_commentContainer__jtSIr","responseContainer":"CommentContainer_responseContainer__suR-G"};